import { useParams } from 'react-router-dom';

export default function useEpdId(): string {
  const { id } = useParams<{ id: string }>();
  return id;
}
